import type { IRangeValue } from "~/types/range";
import { formatNumber, formatPercentageValue } from "~/utils/formatValue";

export const formatRange = (value?: IRangeValue): string => {
  if (value?.min != null && value.max != null) {
    return `${formatNumber(value.min)} – ${formatNumber(value.max)}`;
  }

  if (value?.min != null) {
    return `From ${formatNumber(value.min)}`;
  }

  if (value?.max != null) {
    return `Up to ${formatNumber(value.max)}`;
  }

  return "";
};

export const formatPercentageRange = (
  value?: IRangeValue,
  needToAbs: boolean = true
): string => {
  if (value?.min != null && value.max != null) {
    return `${formatPercentageValue(value.min * 100, { needToAbs })} – ${formatPercentageValue(value.max * 100, { needToAbs })}`;
  }

  if (value?.min != null) {
    return `From ${formatPercentageValue(value.min * 100, { needToAbs })}`;
  }

  if (value?.max != null) {
    return `Up to ${formatPercentageValue(value.max * 100, { needToAbs })}`;
  }

  return "";
};
